const s = {
  name: "Ratio5x2",
  dimensions: { width: 40, height: 16 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 16" style="enable-background:new 0 0 40 16;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M36,4h-6v2h4v4h2V4z"/>
		<path class="st0" d="M6,6v4h4v2H4V6H6z"/>
		<path class="st0" d="M40,0H0v16h40V0z M38,2v12H2V2H38z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Ratio5x2
};
